import React from 'react';
import './navigationIcons.scss';

const SHAPE_ONE = (
    <polygon
        data-spec="shape-one"
        className="navigation-icon__component"
        points="19.4,24.5 19.4,16.4 17.2,16.4 17.5,15.3 20.6,15.3 20.6,24.5"
    />
);
const SHAPE_TWO = (
    <path
        data-spec="shape-two"
        className="navigation-icon__component"
        d="M16.9,24.5L16.9,24.5l3.7-4.1c1-1.1,1.4-1.7,1.4-2.5c0-1-0.5-1.8-1.8-1.8c-1.5,0-1.9,1.1-1.9,2.3h-1.2 c0-1.9,0.9-3.3,3.1-3.3c2.1,0,3,1.2,3,2.8c0,1-0.4,1.7-1.4,2.7c-0.8,0.9-1.8,1.8-2.7,2.8h4.1v1.1H16.9z"
    />
);
const SHAPE_THREE = (
    <path
        data-spec="shape-three"
        className="navigation-icon__component"
        d="M21.6,19.5c1.3,0.3,1.9,1.1,1.9,2.3c0,1.6-1,2.7-3.2,2.7c-2.5,0-3.3-1.3-3.3-3.5h1.1 c0,1.4,0.4,2.4,2.1,2.4c1.4,0,2-0.8,2-1.8c0-1.2-0.8-1.7-2.3-1.7h-0.3V19h0.3c1.5,0,2.2-0.6,2.2-1.6c0-0.9-0.6-1.6-1.8-1.6 c-1.5,0-2,0.9-2,2.1h-1.1c0-1.9,1-3,3.2-3c2,0,2.9,1.1,2.9,2.4C23.2,18.4,22.8,19.2,21.6,19.5z"
    />
);
const SHAPE_FOUR = (
    <path
        data-spec="shape-four"
        className="navigation-icon__component"
        d="M17.7,20.9h3.2v-5.4h0L17.7,20.9z M23.3,20.9v1h-1.3v2.3h-1.2v-2.3H16v-0.1l4-6.8h2.1v5.9H23.3z"
    />
);
const SHAPE_FIVE = (
    <path
        data-spec="shape-five"
        className="navigation-icon__component"
        d="M18.56 24.28a2.43 2.43 0 0 1-1.09-1.17 4 4 0 0 1-.31-1.65h1.06a2.92 2.92 0 0 0 .23 1.22 1.58 1.58 0 0 0 .72.79 2.46 2.46 0 0 0 1.21.27 2.64 2.64 0 0 0 1.26-.28 1.79 1.79 0 0 0 .74-.8 2.62 2.62 0 0 0 .2-1 2.54 2.54 0 0 0-.21-1.06c-.37-.81-1.24-1.22-2.61-1.22a8.83 8.83 0 0 0-1.13.08 7.5 7.5 0 0 0-1.11.25l.74-4.41h4.94l-.2 1h-3.87l-.42 2.43a6.52 6.52 0 0 1 1.49-.18 4.31 4.31 0 0 1 2 .43 2.45 2.45 0 0 1 1.21 1.27 3.45 3.45 0 0 1 .29 1.43 3.32 3.32 0 0 1-.28 1.43 2.53 2.53 0 0 1-1.13 1.2 3.83 3.83 0 0 1-1.87.41 3.85 3.85 0 0 1-1.86-.44z"
    />
);
const SHAPE_CHECK = (
    <polygon
        data-spec="shape-check"
        className="navigation-icon__component navigation-icon__component__check"
        points="28.39,20.21 22.60,26.01 20.18,23.58 19.23,24.54 22.60,27.92 29.35,21.17"
    />
);
const SHAPE_NUMBERS = [
    SHAPE_ONE,
    SHAPE_TWO,
    SHAPE_THREE,
    SHAPE_FOUR,
    SHAPE_FIVE,
];

const SVG_PROPS = {
    className: 'navigation-icon',
    xmlns: 'http://www.w3.org/2000/svg',
    xmlnsXlink: 'http://www.w3.org/1999/xlink',
    x: '0px',
    y: '0px',
    viewBox: '0 0 28 28',
    xmlSpace: 'preserve',
};

const CIRCLE_PROPS = {
    className: 'navigation-icon__circle',
    cx: '14',
    cy: '14',
    r: '14',
};

const CircleIcon = ({ shape }) => (
    <svg {...SVG_PROPS}>
        <circle {...CIRCLE_PROPS} />
        {shape}
    </svg>
);

export const getNavigationIconType = (numOfItems, isCompleted) => {
    let shape;

    if (isCompleted) {
        shape = SHAPE_CHECK;
    } else {
        shape = SHAPE_NUMBERS[numOfItems];
    }

    return <CircleIcon shape={shape} isCompleted={isCompleted} />;
};

/*
 * At the time of writing, custom CSS isn't loading on the manage pages.
 * Unfortunately, inline styles won't work for this scenario because we
 * need styles of a higher specificity to override some things from EDS.
 *
 * This is a hack/workaround.  Please don't copy this pattern.
 * This should be removed when manage custom styles are fixed.
 *
 * Please keep any changes in sync with:
 * ./navigationIcons.scss
 */
export const NavigationIconStyleWorkaround = () => {
    const styles = {
        __html: `
        .navigation-icon path.navigation-icon__component,
        .navigation-icon polygon.navigation-icon__component {
            fill: white !important;
            transform: translate(-6px, -6px);
        }
        .navigation-icon polygon.navigation-icon__component__check {
            transform: translate(-10px, -10px);
        }
        .navigation-icon .navigation-icon__circle {
            fill: #39364F; /* $grey-800 */
        }
        .navigation-icon.navigation-icon--light .navigation-icon__circle {
            fill: #A9A8B3; /* $grey-500 */
        }
    `,
    };

    return (
        <style
            type="text/css"
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={styles}
        />
    );
};
